import type { KeyboardShortcutId } from '@getgo/container-client'
import { asTranslationKey } from '../../common/translate-helpers/i18n-utils'

export const KeyboardShortcutIdTranslation: Partial<Record<KeyboardShortcutId, string>> = {
  newItem: asTranslationKey('newItem'),
  toggleMute: asTranslationKey('toggleMute'),
  toggleCamera: asTranslationKey('toggleCamera'),
  leaveMeetingOrHangUpCall: asTranslationKey('leaveMeetingOrHangUpCall'),
  search: asTranslationKey('search'),
  jumpTo: asTranslationKey('jumpTo'),
  callCurrentContact: asTranslationKey('callCurrentContact'),
  openSoftphone: asTranslationKey('openSoftphone'),
  openSettings: asTranslationKey('openSettings'),
  openMenuBarWindowsOnly: asTranslationKey('openMenuBarWindowsOnly'),
  answerCall: asTranslationKey('answerCall'),
  declineCall: asTranslationKey('declineCall'),
  showPhone: asTranslationKey('showPhone'),
  showInbox: asTranslationKey('showInbox'),
  showMeeting: asTranslationKey('showMeeting'),
  showContact: asTranslationKey('showContact'),
  showContactCenter: asTranslationKey('showContactCenter'),
  showAnalytics: asTranslationKey('showAnalytics'),
  showMeetingParticipants: asTranslationKey('showMeetingParticipants'),
  showMeetingChatMessages: asTranslationKey('showMeetingChatMessages'),
  showSettings: asTranslationKey('showSettings'),
  showNotes: asTranslationKey('showNotes'),
  recordMeeting: asTranslationKey('recordMeeting'),
  raiseHand: asTranslationKey('raiseHand'),
  startStopScreenShare: asTranslationKey('startStopScreenShare'),
  fullScreenMode: asTranslationKey('fullScreenMode'),
  toggleViewMode: asTranslationKey('toggleViewMode'),
  changeVideoFocus: asTranslationKey('changeVideoFocus'),
  holdCall: asTranslationKey('holdCall'),
  transferCall: asTranslationKey('transferCall'),
  dial: asTranslationKey('dial'),
  flip: asTranslationKey('flip'),
  flipToMeeting: asTranslationKey('flipToMeeting'),
  addParticipants: asTranslationKey('addParticipants'),
  parkCall: asTranslationKey('parkCall'),
}

export const KeyboardShortcutErrorCodeTranslation: Record<string, string> = {
  AlreadyUsedGoTo: asTranslationKey('alreadyUsedGoTo'),
  AlreadyUsedSystem: asTranslationKey('alreadyUsedSystem'),
}

export const KeyboardShortcutLocalErrorCodeTranslation = {
  noDuplicate: asTranslationKey('noDuplicateKeyCombination'),
}
